import * as React from "react";
const SvgSort = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 8, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#000", d: "M0 8h4V6.6667H0V8Zm0-8v1.3333h12V0H0Zm0 4.6667h8V3.3333H0v1.3334Z" }));
export default SvgSort;
